const INCH_TO_CM = 2.54

export const convertFtAndInchesToCm = (feet: number, inches: number): number => {
  const totalInches = feet * 12 + inches
  return Math.round(totalInches * INCH_TO_CM)
}
